import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, onUnmounted, ref } from 'vue';

import { Progress } from './components/Progress';
import { OperationData } from './components/OperationData';
import { StrikeOptions } from './components/StrikeOptions';
import { Barriers } from './components/Barriers';
import { OperationResult } from './components/OperationResult';
import { Header } from './components/Header';

import {
  CustomOperation,
  CustomOperationDetailLine
} from '@/modules/trade/services/custom-operations';
import { tooltipsData } from './data';
import { TooltipTypes } from './types';
import { Grid } from '@warrenbrasil/nebraska-web';
import TooltipModal from '@/modules/common/components/TooltipModal/TooltipModal.vue';
import DynamicContentModal from '@/modules/common/components/DynamicContentModal/DynamicContentModal.vue';
import { IDynamicContent } from '@/modules/common/types';

interface Props {
  customOperationData: CustomOperation;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CustomOperationDetailsContent',
  props: {
    customOperationData: null
  },
  setup(__props: any) {

const { customOperationData } = __props as {
  customOperationData: CustomOperation;
}



const isTooltipModalOpen = ref(false);
const tooltipData = ref({ title: '', description: '' });

const isDynamicContentModalOpen = ref(false);
const dynamicContentModal = ref({
  title: '',
  description: [] as IDynamicContent[],
  showCostsButton: false
});

const toggleDynamicModal = (row: CustomOperationDetailLine) => {
  if (row) {
    dynamicContentModal.value.title = row.title;
    dynamicContentModal.value.description = row.disclaimer;
    dynamicContentModal.value.showCostsButton = !!row.action;
  }
  isDynamicContentModalOpen.value = !isDynamicContentModalOpen.value;
};

const windowWidth = ref(window.innerWidth);

const updateWidth = () => {
  windowWidth.value = window.innerWidth;
};

onMounted(() => {
  window.addEventListener('resize', updateWidth);
});

onUnmounted(() => {
  window.removeEventListener('resize', updateWidth);
});

const gridColumns = computed(() => {
  const width = windowWidth.value;
  if (width > 1024) {
    return [1, 1, 1];
  } else if (width > 768) {
    return [1, 1];
  } else {
    return [1];
  }
});

const hasStrikeOptions = computed(() => {
  return (
    customOperationData?.strikeOptions &&
    customOperationData?.strikeOptions?.length > 0
  );
});

const hasMonitoringBarriers = computed(() => {
  return (
    customOperationData?.monitoring &&
    customOperationData?.monitoring?.length > 0
  );
});

const handleOpenTooltipModal = (type: TooltipTypes) => {
  tooltipData.value = tooltipsData[type];
  isTooltipModalOpen.value = true;
};

const handleCloseTooltipModal = () => {
  isTooltipModalOpen.value = false;
};

return { __sfc: true,isTooltipModalOpen, tooltipData, isDynamicContentModalOpen, dynamicContentModal, toggleDynamicModal, windowWidth, updateWidth, gridColumns, hasStrikeOptions, hasMonitoringBarriers, handleOpenTooltipModal, handleCloseTooltipModal, Progress, OperationData, StrikeOptions, Barriers, OperationResult, Header, Grid, TooltipModal, DynamicContentModal }
}

})